<template>
     <input 
     type="text" 
     class="transition-colors duration-150 block w-full px-4 py-3 text-sm rounded-lg border-2 text-gray-600 bg-gray-100 border-gray-100 hover:bg-gray-200 hover:border-gray-200 focus:bg-gray-200 focus:border-gray-200 dark:text-gray-200 dark:bg-gray-800 dark:border-gray-800 dark:hover:bg-gray-700 dark:hover:border-gray-700 dark:focus:bg-gray-700 dark:focus:border-gray-700">
</template>